import styled from "styled-components";
import { AutoComplete, Input } from "antd";
import { RATypography } from "../Typography";
import { IconCloseSvg } from "@/components/svgs";
import { SvgClear } from "@/assets/icons";

export const RAAutoComplete = ({
	value,
	onSelect,
	handleSearch,
	prefix,
	suffix,
	width = "100%",
	height = "52px",
	placeholder = "Enter ...",
	title,
	error,
	options = [],
	allowClear = true,
	onClear,
	disabled,
}) => {
	return (
		<WrapperInput disabled={disabled}>
			{title && (
				<WrapperTitle>
					<RATypography color="#595959" variant="sub-heading4">
						{title}
					</RATypography>
				</WrapperTitle>
			)}
			<AutoComplete
				dropdownMatchSelectWidth={252}
				style={{ width: width }}
				options={options}
				onSelect={onSelect}
				disabled={disabled}
				onSearch={handleSearch}
				value={value}
				allowClear={allowClear}
				onClear={onClear}
				clearIcon={<SvgClear />}
			>
				<Input
					placeholder={placeholder}
					prefix={prefix}
					suffix={suffix}
					style={{ width: width, height: height }}
				/>
			</AutoComplete>
			{!!error && (
				<RATypography variant="body3" color="#BF1A2F" top="4px">
					{error}
				</RATypography>
			)}
		</WrapperInput>
	);
};

const WrapperInput = styled.div`
	.ant-input,
	.ant-input-status-success {
		background: transparent;
		outline: 0;
	}
	.ant-select .ant-select-clear {
		width: 20px;
		height: 20px;
		margin-top: -10px;
	}
	.ant-input {
		&:hover {
			outline: none;
			border-color: #ffb11a;
		}
		&:focus {
			outline: none;
			border-color: #ffb11a;
			box-shadow: 0px 0px 2px #ffb11a;
		}
	}
	.ant-input-affix-wrapper {
		padding: 10px 20px;
		border-color: #e9e8e8;
		&:hover {
			outline: none;
			border-color: #ffb11a;
		}
		&:focus {
			outline: none;
			border-color: #ffb11a;
			box-shadow: 0px 0px 2px #ffb11a;
		}
	}
	.ant-input-number-affix-wrapper {
		&:hover {
			outline: none;
			border-color: #ffb11a;
		}
		&:focus {
			outline: none;
			border-color: #ffb11a;
			box-shadow: 0px 0px 2px #ffb11a;
		}
	}
	.ant-input-number-affix-wrapper > div.ant-input-number {
		height: 100%;
		display: flex;
		align-items: center;
	}
	${({ disabled }) =>
		disabled &&
		`
        .ant-input-affix-wrapper-disabled, .ant-input-affix-wrapper[disabled] {
            border: none;
            background-color: #F9F9F9;
        }
    `}
`;
const WrapperTitle = styled.div`
	padding-bottom: 8px;
`;
